import pug from 'javascripts/notifications/templates/notification_spinner.jst.pug';
window.JST = window.JST || {};
window.JST['notifications/templates/notification_spinner'] = pug;
